import {BaseContainerModel} from '../base-container.model';
import {bl_asv_consultation_checklist_detail_line_RowClass} from '../../dbschema';

export class AsvConsultationChecklistDetailLineModel extends BaseContainerModel {
    bl_asv_consultation_checklist_detail_line: bl_asv_consultation_checklist_detail_line_RowClass = new bl_asv_consultation_checklist_detail_line_RowClass();
}
